import { stipAxios } from '../axios';
import { EXTERNAL_CONTEXT } from 'app/config/urls';

const BASE_ENDPOINT = '/servico';

const surveyEndpoints = {
    getAllServicesStatus: () => stipAxios.get('/situacao'),
    getServices: () => stipAxios.get(`${EXTERNAL_CONTEXT}${BASE_ENDPOINT}`),
    getServicesByUser: (cdUsuario) => stipAxios.get(`${BASE_ENDPOINT}/by-usuario/${cdUsuario}`),
    getAllServices: () => stipAxios.get(`${EXTERNAL_CONTEXT}${BASE_ENDPOINT}/find-all`),
    getInternalServices: () => stipAxios.get(`${BASE_ENDPOINT}`),
    getGuestServices: () => stipAxios.get(`/guest${BASE_ENDPOINT}`),
    downloadWidgetItem: (pdf) => stipAxios.get(`${pdf}`),
    getSectorResponsible: (cdServico) =>
        stipAxios.get(`${EXTERNAL_CONTEXT}/setor/find-responsavel-by-servico/${cdServico}`),
    getServiceDocuments: (params) =>
        stipAxios.post(`${EXTERNAL_CONTEXT}${BASE_ENDPOINT}/documentos`, {
            ...params,
        }),
};

export default surveyEndpoints;
